import UniEmoji from "./uni/UniEmoji";
import { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux-share/hooks";
import { getEmojiUrl } from "../../../../../services";
import { setEmojiList1, setEmojiList2 } from "redux-share/slices/videoDataSlice";
import { activeElementsTime, checkParentTarget, conditions, isTouchScreen } from "helpers";
import { ConditionName, IEmoji } from "interfaces";
import useOnClickOutside from "helpers/hooks/useOnClickOutside";
import { shallowEqual } from "react-redux";
import dynamic from "next/dynamic";

const Emoji = dynamic(() => import("../emoji/emoji"));
const SprayEmoji = dynamic(() => import("./spray/SprayEmoji"));
const ExplodeEmoji = dynamic(() => import("./explode/ExplodeEmoji"));

const InstagramEmoji = () => {
    const dispatch = useAppDispatch();
    const { emojis, emojiList1, emojiList2, config } = useAppSelector(
        ({ videoData: { emojis, emojiList1, emojiList2, config } }) => ({ emojis, emojiList1, emojiList2, config }),
        shallowEqual
    );
    useAppSelector(({ controller: { activeElements } }) => ({ activeElements }), shallowEqual);

    // user reaction
    const [rightAccumulateEmoji, setRightAccumulateEmoji] = useState<string[]>([]);
    const [leftAccumulateEmoji, setLeftAccumulateEmoji] = useState<string[]>([]);

    // backend normalize coefficient
    const [normCoefficient, setNormCoefficient] = useState<number>(0);

    // backend response reaction --- RIGHT LIST ( list2 )
    const [uniListRight, setUniListRight] = useState<{ code: string; count: number }[]>([]);
    const [explodeListRight, setExplodeListRight] = useState<string[]>([]);
    const [sprayListRight, setSprayListRight] = useState<string[]>([]);

    // backend response reaction --- LEFT LIST ( list1 )
    const [uniListLeft, setUniListLeft] = useState<{ code: string; count: number }[]>([]);
    const [explodeListLeft, setExplodeListLeft] = useState<string[]>([]);
    const [sprayListLeft, setSprayListLeft] = useState<string[]>([]);

    // open state of reaction menu
    const [openRightWoodSeller, setOpenRightWoodSeller] = useState<boolean>(false);
    const [openLeftWoodSeller, setOpenLeftWoodSeller] = useState<boolean>(false);

    const [closeTimeoutIdRight, setCloseTimeoutIdRight] = useState<any>(null);
    const [closeTimeoutIdLeft, setCloseTimeoutIdLeft] = useState<any>(null);
    const [transparencyIcon, setTransparencyIcon] = useState(false);
    const [transparencyTimeoutId, setTransparencyTimeoutId] = useState<any>(null);

    const rightWoodSellerRef = useRef(null);
    const leftWoodSellerRef = useRef(null);

    const rightSideUserEmojiReactionGenerator = async (sticker: any, id: string) => {
        const createSticker = (sticker: any) => {
            let CustomEmoji = document.createElement("img");
            CustomEmoji.src = `${getEmojiUrl()}/${sticker}.png`;
            CustomEmoji.id = `${sticker}-${rightAccumulateEmoji.length}`;
            CustomEmoji.classList.add("pl-user-uni-emoji-right");
            CustomEmoji.classList.add("pl-customEmoji");
            CustomEmoji.classList.add(`${sticker}-${rightAccumulateEmoji.length}`);
            return CustomEmoji;
        };

        let commentSticker = await createSticker(sticker);
        const parent = document.getElementById(id);
        if (parent) {
            parent.appendChild(commentSticker);
            setTimeout(() => {
                if (parent) parent?.removeChild(commentSticker);
            }, 6 * 1000);
        }
    };

    const leftSideUserEmojiReactionGenerator = async (sticker: any, id: string) => {
        const createSticker = (sticker: any) => {
            let CustomEmoji = document.createElement("img");
            CustomEmoji.src = `${getEmojiUrl()}/${sticker}.png`;
            CustomEmoji.id = `${sticker}-${leftAccumulateEmoji.length}`;
            CustomEmoji.classList.add("pl-user-uni-emoji-left");
            CustomEmoji.classList.add("pl-customEmoji-left");
            CustomEmoji.classList.add(`${sticker}-${leftAccumulateEmoji.length}`);
            return CustomEmoji;
        };

        let commentSticker = await createSticker(sticker);
        const parent = document.getElementById(id);
        if (parent) {
            parent.appendChild(commentSticker);
            setTimeout(() => {
                if (parent) parent?.removeChild(commentSticker);
            }, 6 * 1000);
        }
    };

    const getRightUserReaction = (emojiCode: string) => {
        const recentEmojiList = emojiList2;
        if (recentEmojiList.length === 0 || !recentEmojiList.includes(emojiCode)) {
            dispatch(setEmojiList2([...emojiList2, emojiCode]));
        }
    };
    const getLeftUserReaction = (emojiCode: string) => {
        const recentEmojiList = emojiList1;
        if (recentEmojiList.length === 0 || !recentEmojiList.includes(emojiCode)) {
            dispatch(setEmojiList1([...emojiList1, emojiCode]));
        }
    };

    const timeoutHandlerMenu = (setOpenWoodSeller: any, setCloseTimeoutId: any) => {
        let timeoutId: any;
        timeoutId = setTimeout(() => {
            setOpenWoodSeller(false);
        }, activeElementsTime);
        setCloseTimeoutId(timeoutId);
    };

    useEffect(() => {
        if (openLeftWoodSeller) timeoutHandlerMenu(setOpenLeftWoodSeller, setCloseTimeoutIdLeft);
        else clearTimeout(closeTimeoutIdLeft);
    }, [openLeftWoodSeller]);

    useEffect(() => {
        if (openRightWoodSeller) timeoutHandlerMenu(setOpenRightWoodSeller, setCloseTimeoutIdRight);
        else clearTimeout(closeTimeoutIdRight);
    }, [openRightWoodSeller]);

    useEffect(() => {
        if (conditions(ConditionName.hasEmojis)) {
            let maxCountOfEmojiList1: number = 0;
            let maxCountOfEmojiList2: number = 0;
            let uniListTempRight: any[] = [];
            let ExplodeListTempRight: any[] = [];
            let sprayListTempRight: any[] = [];
            let uniListTempLeft: any[] = [];
            let ExplodeListTempLeft: any[] = [];
            let sprayListTempLeft: any[] = [];
            emojis.emoji_list_2_result.forEach((item: IEmoji) => {
                if (item.explode) {
                    ExplodeListTempRight.push(item.code);
                }
                if (item.spray) {
                    sprayListTempRight.push(item.code);
                }
                if (item.count > 0) {
                    maxCountOfEmojiList2 = item.count;
                    uniListTempRight.push({ code: item.code, count: item.count });
                }
            });
            emojis.emoji_list_1_result.forEach((item: IEmoji) => {
                if (item.explode) {
                    ExplodeListTempLeft.push(item.code);
                }
                if (item.spray) {
                    sprayListTempLeft.push(item.code);
                }
                if (item.count > 0) {
                    maxCountOfEmojiList1 = item.count;
                    uniListTempLeft.push({ code: item.code, count: item.count });
                }
            });
            setExplodeListRight(ExplodeListTempRight);
            setSprayListRight(sprayListTempRight);
            setUniListRight(uniListTempRight);
            setExplodeListLeft(ExplodeListTempLeft);
            setSprayListLeft(sprayListTempLeft);
            setUniListLeft(uniListTempLeft);
            setNormCoefficient(
                Math.max(maxCountOfEmojiList2, maxCountOfEmojiList1) > 2 * config.interval
                    ? (2 * config.get_interval) / Math.max(maxCountOfEmojiList2, maxCountOfEmojiList1)
                    : 1
            );
        }
    }, [emojis]);

    useOnClickOutside(rightWoodSellerRef, (event) => {
        if (!checkParentTarget(event, "emojiButtonRight")) setOpenRightWoodSeller(false);
    });

    useOnClickOutside(leftWoodSellerRef, (event) => {
        if (!checkParentTarget(event, "emojiButtonLeft")) setOpenLeftWoodSeller(false);
    });

    useEffect(() => {
        let elementRight = document.getElementById("emojiButtonRight");
        let elementLeft = document.getElementById("emojiButtonLeft");
        if (elementLeft) elementLeft.style.opacity = "1";
        if (elementRight) elementRight.style.opacity = "1";
        if (!!transparencyTimeoutId) clearTimeout(transparencyTimeoutId);
        let id: any;
        id = setTimeout(() => {
            if (elementLeft) elementLeft.style.opacity = "0.85";
            if (elementRight) elementRight.style.opacity = "0.85";
        }, activeElementsTime);
        setTransparencyTimeoutId(id);
    }, [transparencyIcon]);

    return (
        <div
            className={`pl-flex pl-w-full pl-absolute pl-justify-between pl-cursor-pointer ${
                conditions(ConditionName.isComplexPortrait)
                    ? `-pl-bottom-[30px]`
                    : `pl-bottom-0 animate__animated pl-transition-all pl-duration-500 ${
                          conditions(ConditionName.instagramEmojiAnimation)
                              ? "animate__fadeInUp pl-opacity-100 pl-pointer-events-auto"
                              : "animate__fadeOutDown pl-opacity-0 pl-pointer-events-none"
                      }`
            }`}
        >
            <div className="pl-w-[50px] pl-relative" id="rightWoodSeller" />
            <div className="pl-w-full pl-relative" id="leftWoodSeller" dir="ltr" />
            {emojis.emoji_list_1 !== "" && (!conditions(ConditionName.isComplexPortrait) || !openLeftWoodSeller) && (
                <div
                    id="emojiButtonLeft"
                    className={`pl-z-[1000] pl-absolute ${
                        conditions(ConditionName.isComplexPortrait)
                            ? `pl-bottom-4 pl-border-l-0 pl-rounded-tr-full -pl-left-2 pl-h-[50px] pl-w-[50px] pl-bg-z-secondary-100 dark:pl-bg-black pl-border-[1.5px] pl-border-z-secondary-500 dark:pl-border-white`
                            : `pl-bottom-5 pl-rounded-full pl-left-3 ${
                                  isTouchScreen() && conditions(ConditionName.isFullScreen) ? "pl-h-[50px] pl-w-[50px]" : "pl-h-[38px] pl-w-[38px]"
                              } pl-bg-opacity-30 pl-bg-black pl-border-[1.5px] pl-border-white`
                    }`}
                    onClick={(e) => {
                        e.preventDefault();
                        setTransparencyIcon(!transparencyIcon);
                        setOpenRightWoodSeller(false);
                        if (emojis.emoji_list_1.split("|").length > 1) setOpenLeftWoodSeller(!openLeftWoodSeller);
                        else {
                            leftSideUserEmojiReactionGenerator(emojis.emoji_list_1.split("|")[0], "leftWoodSeller");
                            getLeftUserReaction(emojis.emoji_list_1.split("|")[0]);
                            setLeftAccumulateEmoji((prev) => [...prev, emojis.emoji_list_1.split("|")[0]]);
                        }
                    }}
                >
                    <div className="pl-flex pl-items-center pl-justify-center pl-w-full pl-h-full">
                        <div
                            className={`pl-flex pl-w-full pl-mx-auto pl-justify-center pl-items-center ${
                                conditions(ConditionName.isComplexPortrait) && "pl-mr-2 pl-mt-2"
                            }`}
                        >
                            <Emoji
                                name={emojis.emoji_list_1.split("|")[0]}
                                className={`${
                                    conditions(ConditionName.isComplexPortrait)
                                        ? "pl-w-[22px] pl-h-[22px]"
                                        : isTouchScreen() && conditions(ConditionName.isFullScreen)
                                        ? "pl-w-[30px] pl-h-[30px]"
                                        : "pl-w-[24px] pl-h-[24px]"
                                }`}
                            />
                            <div />
                        </div>
                    </div>
                </div>
            )}
            {emojis.emoji_list_1 !== "" && (
                <div
                    ref={leftWoodSellerRef}
                    id="menuIconLeft"
                    className={`${!openLeftWoodSeller && "pl-hidden"} pl-absolute no-scrollbar ${
                        conditions(ConditionName.isComplexPortrait)
                            ? `pl-w-[32px] pl-max-h-[152px] pl-overflow-y-auto pl-py-3 pl-left-0 pl-bottom-[19px] pl-z-50 pl-bg-z-secondary-100 dark:pl-bg-black pl-border-z-secondary-500 dark:pl-border-white`
                            : "pl-h-[32px] pl-max-w-[152px] pl-overflow-x-auto pl-px-3 pl-py-1 pl-left-3 pl-bottom-[75px] pl-bg-opacity-30 pl-bg-black pl-border-white"
                    } pl-rounded-full pl-border-[1.5px]`}
                >
                    {openLeftWoodSeller && (
                        <div
                            className={`${
                                emojis.emoji_list_1.split("|").length > 1 &&
                                `pl-gap-3 ${conditions(ConditionName.isComplexPortrait) ? "pl-h-max" : "pl-w-max"}`
                            } pl-flex pl-items-center pl-justify-center ${
                                conditions(ConditionName.isComplexPortrait)
                                    ? "pl-flex-col md:pl-max-h-[260px] pl-max-h-[220px] pl-w-full"
                                    : "pl-flex-row md:pl-max-w-[260px] pl-max-w-[220px] pl-h-full pl-py-1"
                            }`}
                        >
                            {emojis.emoji_list_1.split("|").map((item: string, index: number) => {
                                return (
                                    <div
                                        key={index}
                                        className={`pl-flex pl-w-full pl-justify-center`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if (closeTimeoutIdLeft) {
                                                clearTimeout(closeTimeoutIdLeft);
                                                timeoutHandlerMenu(setOpenLeftWoodSeller, setCloseTimeoutIdLeft);
                                            }
                                            setTransparencyIcon(!transparencyIcon);
                                            setOpenRightWoodSeller(false);
                                            leftSideUserEmojiReactionGenerator(item, "leftWoodSeller");
                                            getLeftUserReaction(item);
                                            setLeftAccumulateEmoji((prev) => [...prev, item]);
                                        }}
                                    >
                                        <Emoji name={item} className={`pl-w-[24px] pl-h-[24px]`} />
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            )}
            {emojis.emoji_list_2 !== "" && (!conditions(ConditionName.isComplexPortrait) || !openRightWoodSeller) && (
                <div
                    id="emojiButtonRight"
                    className={`pl-z-[1000] pl-overflow-x-auto no-scrollbar pl-absolute  ${
                        conditions(ConditionName.isComplexPortrait)
                            ? "pl-border-r-0 pl-rounded-tl-full pl-bottom-4 pl-h-[50px] pl-w-[50px] -pl-right-2 pl-bg-z-secondary-100 dark:pl-bg-black pl-border-z-secondary-500 dark:pl-border-white"
                            : `pl-rounded-full pl-bottom-5 pl-bg-opacity-30 ${
                                  isTouchScreen() && conditions(ConditionName.isFullScreen) ? "pl-h-[50px] pl-w-[50px]" : "pl-h-[38px] pl-w-[38px]"
                              } pl-right-3 pl-bg-black pl-border-white`
                    } pl-border-[1.5px]`}
                    onClick={(e) => {
                        e.preventDefault();
                        setOpenLeftWoodSeller(false);
                        setTransparencyIcon(!transparencyIcon);
                        if (emojis.emoji_list_2.split("|").length > 1) setOpenRightWoodSeller(!openRightWoodSeller);
                        else {
                            getRightUserReaction(emojis.emoji_list_2.split("|")[0]);
                            setRightAccumulateEmoji((prev) => [...prev, emojis.emoji_list_2.split("|")[0]]);
                            rightSideUserEmojiReactionGenerator(emojis.emoji_list_2.split("|")[0], "rightWoodSeller");
                        }
                    }}
                >
                    <div className="pl-flex pl-items-center pl-justify-center pl-w-full pl-h-full">
                        <div
                            className={`pl-flex pl-w-full pl-mx-auto pl-justify-center ${
                                conditions(ConditionName.isComplexPortrait) && "pl-mt-2 pl-ml-2"
                            }`}
                        >
                            <Emoji
                                name={emojis.emoji_list_2.split("|")[0]}
                                className={`${
                                    conditions(ConditionName.isComplexPortrait)
                                        ? "pl-w-[22px] pl-h-[22px]"
                                        : isTouchScreen() && conditions(ConditionName.isFullScreen)
                                        ? "pl-w-[30px] pl-h-[30px]"
                                        : "pl-w-[24px] pl-h-[24px]"
                                }`}
                            />
                        </div>
                    </div>
                </div>
            )}
            {emojis.emoji_list_2 !== "" && (
                <div
                    dir={"ltr"}
                    id="menuIconRight"
                    ref={rightWoodSellerRef}
                    className={`${!openRightWoodSeller && "pl-hidden"} ${
                        conditions(ConditionName.isComplexPortrait)
                            ? "pl-max-h-[152px] pl-overflow-y-auto pl-w-[32px] pl-right-0 pl-bottom-[19px] pl-py-3 pl-z-50 pl-bg-z-secondary-100 dark:pl-bg-black pl-border-z-secondary-500 dark:pl-border-white"
                            : "pl-max-w-[152px] pl-overflow-x-auto pl-h-[32px] pl-right-3 pl-bottom-[75px] pl-px-3 pl-py-1 pl-bg-opacity-30 pl-bg-black pl-border-white"
                    } no-scrollbar pl-absolute pl-rounded-full pl-border-[1.5px]`}
                >
                    {openRightWoodSeller && (
                        <div
                            className={`${
                                emojis.emoji_list_2.split("|").length > 1 &&
                                `pl-gap-3 ${conditions(ConditionName.isComplexPortrait) ? "pl-h-max" : "pl-w-max"}`
                            } pl-flex ${
                                conditions(ConditionName.isComplexPortrait)
                                    ? "pl-flex-col md:pl-max-h-[260px] pl-max-h-[220px] pl-w-full"
                                    : "md:pl-max-w-[260px] pl-max-w-[220px] pl-h-full"
                            } pl-py-1 pl-items-center pl-justify-center pl-m-0`}
                        >
                            {emojis.emoji_list_2.split("|").map((item: string, index: number) => {
                                return (
                                    <div
                                        key={index}
                                        className={`pl-flex pl-w-full pl-justify-center`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if (closeTimeoutIdRight) {
                                                clearTimeout(closeTimeoutIdRight);
                                                timeoutHandlerMenu(setOpenRightWoodSeller, setCloseTimeoutIdRight);
                                            }
                                            setTransparencyIcon(!transparencyIcon);
                                            setOpenLeftWoodSeller(false);
                                            getRightUserReaction(item);
                                            setRightAccumulateEmoji((prev) => [...prev, item]);
                                            rightSideUserEmojiReactionGenerator(item, "rightWoodSeller");
                                        }}
                                    >
                                        <Emoji name={item} className={`pl-w-[24px] pl-h-[24px]`} />
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            )}
            <div>
                {uniListRight.length > 0 && normCoefficient && (
                    <UniEmoji normalizeCoefficient={normCoefficient} direction={"RIGHT"} EmojiList={uniListRight} />
                )}
            </div>
            <div>
                {uniListLeft.length > 0 && normCoefficient && (
                    <UniEmoji normalizeCoefficient={normCoefficient} direction={"LEFT"} EmojiList={uniListLeft} />
                )}
            </div>
            {explodeListRight.length > 0 && <ExplodeEmoji direction={"RIGHT"} codes={explodeListRight} />}
            {explodeListLeft.length > 0 && <ExplodeEmoji direction={"LEFT"} codes={explodeListLeft} />}
            {sprayListRight.length > 0 && <SprayEmoji direction={"RIGHT"} codes={sprayListRight} />}
            {sprayListLeft.length > 0 && <SprayEmoji direction={"LEFT"} codes={sprayListLeft} />}
        </div>
    );
};

export default InstagramEmoji;
